import { createBrowserRouter } from "react-router-dom";

import LandingPage from "../pages/UnauthorizedPages/LandingPage";
import HomePage from "../pages/UnauthorizedPages/HomePage";
import BlogsDescriptionPage from "../pages/UnauthorizedPages/BlogsDescriptionPage";
import PageNotFound from "../pages/PageNotFound";
import BlogDetailsPage from "../pages/UnauthorizedPages/BlogDetailsPage";
import DevBlogDetailsPage from "../pages/UnauthorizedPages/DevBlogDetailsPage";
import PrivacyOfServicePage from "../pages/UnauthorizedPages/PrivacyOfServicePage";
import TermsOfServicePage from "../pages/UnauthorizedPages/TermsOfServicePage";

import LoginPage from "../pages/UnauthorizedPages/LoginPage";

import { AdminProtectedRoute } from "../features/admin/components";
import AdminPage from "../pages/AuthorizedPages/AdminPage";
import AdminDashboard from "../pages/AuthorizedPages/AdminDashboard";
import CreateBlogPage from "../pages/AuthorizedPages/CreateBlogPage";
import ViewBlogsPage from "../pages/AuthorizedPages/ViewBlogsPage";
import ViewPostsPage from "../pages/AuthorizedPages/ViewPostsPage";
import CreateTipPage from "../pages/AuthorizedPages/CreateTipPage";
import ViewTipsPage from "../pages/AuthorizedPages/ViewTipsPage";
import ViewReportedUsersPage from "../pages/AuthorizedPages/ViewReportedUsersPage";
import ViewListOfUsersPage from "../pages/AuthorizedPages/ViewListOfUsersPage";
import ViewSupportMessagesPage from "../pages/AuthorizedPages/ViewSupportMessagesPage";
import ViewDisabledUsersPage from "../pages/AuthorizedPages/ViewDisabledUsersPage";
import ViewTripsPage from "../pages/AuthorizedPages/ViewTripsPage";
import ViewSubscribeUsersPage from "../pages/AuthorizedPages/ViewSubscribedUsersPage";
import ViewUnverifiedUsersPage from "../pages/AuthorizedPages/ViewUnverifiedUsersPage";


const router = createBrowserRouter([
  // Unauthorized Routes
  {
    path: "/",
    element: <LandingPage />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/blogs",
        element: <BlogsDescriptionPage />,
      },
      {
        path: "/privacy",
        element: <PrivacyOfServicePage />,
      },
      {
        path: "/terms",
        element: <TermsOfServicePage />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: "/blog/:id",
    element: <BlogDetailsPage />,
  },
  {
    path: "/dev/blog/:id",
    element: <DevBlogDetailsPage />,
  },
  {
    path: "/admin/login",
    element: <LoginPage />,
    children: [
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },

  // Authorized Routes
  {
    path: "/admin",
    element: (
      <AdminProtectedRoute>
        <AdminPage />
      </AdminProtectedRoute>
    ),
    children: [
      {
        path: "",
        element: <AdminDashboard />,
      },
      {
        path: "blog",
        element: <CreateBlogPage />,
      },
      {
        path: "blog-list",
        element: <ViewBlogsPage />,
      },
      {
        path: "post-list",
        element: <ViewPostsPage />,
      },
      {
        path: "tip",
        element: <CreateTipPage />,
      },
      {
        path: "tips-list",
        element: <ViewTipsPage />,
      },
      {
        path: "reported-users",
        element: <ViewReportedUsersPage />,
      },
      {
        path: "list",
        element: <ViewListOfUsersPage />,
      },
      {
        path: "support",
        element: <ViewSupportMessagesPage />,
      },
      {
        path: "disabled-users",
        element: <ViewDisabledUsersPage />,
      },
      {
        path: "trip",
        element: <ViewTripsPage />,
      },
      {
        path: "subscribe-users",
        element: <ViewSubscribeUsersPage />,
      },
      {
        path: "unverified-users",
        element: <ViewUnverifiedUsersPage />,
      },
    ],
  },
]);

export default router;
